<template>
  <div class="view package">
    <div class="loading" :class="{show: loading}"></div>

    <h1>{{ model.name }}</h1>

    <div class="container">

      <!-- Package Info -->
      <div class="meta">
      <!-- Same as Activity page >>>>> -->
        <div class="image-container">
          <img :src="packageImage" alt="{Activity image caption}" class="image">
        </div>

        <ol class="icons">
          <li v-if="duration" ><span class="icon-duration"></span><duration :hours="duration"/></li>
          <!-- TODO: Display start time here if there is one -->
          <!-- <li v-if="model.duration" ><span class="icon-time"></span>10:00 am</li> -->
          <li v-if="model.hasLunch" ><span class="icon-lunch"></span>{{ $t('general.label.has-lunch') }}</li>
          <li v-if="model.hasPickup" ><span class="icon-pickup"></span>{{ $t('general.label.has-pickup') }}</li>
          <li v-if="model.hasGiftCert" ><span class="icon-gift"></span>{{ $t('general.label.has-giftcert') }}</li>
        </ol>

        <p class="description" v-html="model.description"></p>

        <div v-if="model.moreInfo" class="more-info">
          <input id="more-info-toggle" class="toggle-button" type="checkbox">
          <label for="more-info-toggle">{{ $t('general.label.more-info') }}</label>
          <p v-html="model.moreInfo"></p>
        </div>

        <div v-if="model.policies" class="policy">
          <input id="policy-toggle" class="toggle-button" type="checkbox">
          <label for="policy-toggle">{{ $t('general.label.cancel-policy') }}</label>
          <p v-html="model.policies"></p>
        </div>
        <!-- <<<<< Same as Activity page -->


        <div class="content">

          <h2 class="content-header">{{ $t('package.content') }}</h2>

          <div v-for="(activity, index) in model.activities" :key="activity.id">
            <div class="day-number" v-if="shouldShowDayNumber(index, activity.dayNumber)">{{ $t('general.label.day') + " " + activity.dayNumber}}</div>

            <div class="item">
              <div class="item-image-container">
                <!-- Show Activity image. If it doesn't have, show abstract.png -->
                <img :src="activity.imageUrl" alt="" class="item-image">
                <div class="item-name">{{ activity.name }}</div>
              </div>

              <div class="item-description" v-html="activity.additionalBookingInformation"></div>

              <div v-if="activity.moreInfo.length" class="item-note">
                <!-- To Jamie: Need to change this input id="" and label for="" name for each items to make the toggle work -->
                <input :id="'info-toggle' + activity.id" class="item-toggle-button" type="checkbox">
                <label :for="'info-toggle' + activity.id">{{ $t('general.label.more-info') }}</label>
                <p v-html="activity.moreInfo"></p>
              </div>

              <div v-if="activity.tourPolicy.length" class="item-note">
                <!-- To Jamie: Need to change this input id="" and label for="" name for each items to make the toggle work -->
                <input :id="'policy-toggle' + activity.id" class="item-toggle-button" type="checkbox">
                <label :for="'policy-toggle' + activity.id">{{ $t('general.label.cancel-policy') }}</label>
                <p v-html="activity.tourPolicy"></p>
              </div>

              <div v-if="activity.notes.length" class="item-note">
                <!-- To Jamie: Need to change this input id="" and label for="" name for each items to make the toggle work -->
                <input :id="'notes-toggle' + activity.id" class="item-toggle-button" type="checkbox">
                <label :for="'notes-toggle' + activity.id">{{ $t('general.label.notes-restrictions') }}</label>
                <p v-html="activity.notes"></p>
              </div>
            </div>

          </div>

          <div v-for="product in model.products" :key="product.id">
            <!-- PRODUCT start -->
            <div class="item">
              <div class="item-image-container">
                <!-- Show Product image. If it doesn't have, show abstract.png -->
                <img src="../assets/images/abstract.png" alt="" class="item-image">
                <div class="item-name">{{ product.name }}</div>
              </div>

              <div class="item-description">{{ product.description }}</div>

            </div>
            <!-- PRODUCT end -->
          </div>

        </div>

      </div>


      <!-- Form -->
      <div class="form" v-bind:class="{ active: bookNowActive }">
      <!-- Same as Activity page >>>>> -->
        <!-- Mobile fixed Book Now button -->
        <div class="mobile-fixed-button">
          <button v-on:click="bookNowToggle" class="mobile-book-now">
            <span v-if="showLowestPrice" class="from">{{ $t('general.label.price-from') }}</span>
            <span v-if="showLowestPrice" class="price">{{ $formatter.currency(model.listPrice)}}</span>
            {{ $t('general.label.book-now') }}
          </button>
        </div>

        <div class="inputs" v-bind:class="{ active: giftCertActive }">
        <!-- <<<<< Same as Activity page -->


          <!-- Default inputs -->
          <div class="default-inputs">

            <div class="common-inputs">
              <h3>{{ $t('package.select-passengers-and-date') }}</h3>
              <availability-calendar v-if="model.isMultiDayItinerary || model.isSingleDayOnly" :value="activeDate" @input="updateActiveDate" :inline="false" :enabled="model.availability"/>

              <!-- Guest -->
              <guest-picker v-if="paxEnabled.length" ref="guestPicker" :pricing="model.price" :paxPrefix="paxPrefix" :enabled="paxEnabled" :value="guestPickerPax" @input="onGuestPickerUpdate"/>
            </div>

            <div class="item-specific-inputs">

              <div v-for="activityCartItem in cartItem.packageActivities" :key="activityCartItem.itemId">
                <!--
                <div class="day-number" v-if="shouldShowDayNumber(index, activityCartItem.details.dayNumber)">{{ $t('general.label.day') + " " + activityCartItem.details.dayNumber}}</div>
                -->

                <!-- ITEM start -->
                <div class="item-container">

                  <div class="activity-bar">
                    <div class="info">
                      <p>{{$formatter.date(activityCartItem.rawDate)}}</p>
                      <h3 v-if="activityCartItem.details">{{ activityCartItem.details.name }}</h3>
                    </div>
                    <a @click="menuCaretClick(activityCartItem.itemId, $event)" class="caret down"></a>
                  </div>

                  <div :ref="`section_${activityCartItem.itemId}`" class="activity-section collapsed">
                    <!-- To Jamie: If "Restrict content bookings on same day" is OFF, show date here. DONE-->
                    <availability-calendar v-if="!model.isMultiDayItinerary && !model.isSingleDayOnly && activityCartItem.details" v-model="activityCartItem.rawDate" @input="updateDates" :inline="false" :enabled="activityCartItem.details.availability"/>

                    <!-- Interval and rental activities only -->
                    <form-input type="select" v-if="activityCartItem.details && startTimesActive(activityCartItem.details)" :label="$t('form.label.start-time')" icon="time" :options="startTimes(activityCartItem)" class="highlighted-info" v-model="activityCartItem.startTime"/>
                    <form-input type="select" v-if="activityCartItem.details && endTimesActive(activityCartItem.details)" :label="$t('form.label.dropoff-time')" icon="time" :options="dropoffTimes(activityCartItem)" v-model="activityCartItem.endTime"/>


                    <form-input v-if="activityCartItem.details && activityCartItem.details.pickups.length" type="select" :label="$t('form.label.pickup-location')" :options="pickupLocations(activityCartItem.details)" icon="pickup" v-model="activityCartItem.pickupLocation"/>
                    <p class="availability error" v-if="activityCartItem.details && requiredFrontEndPickup && activityCartItem.details.pickups.length && !activityCartItem.pickupLocation">{{ $t('form.label.pickup-required') }}</p>

                    <form-input v-if="activityCartItem.details && activityCartItem.details.enablePickupSelectionOnline" type="text" :label="$t('form.label.pickup-address')" icon="pickupaddress" v-model="activityCartItem.pickupAddress"/>
                    <form-input v-if="activityCartItem.details && activityCartItem.details.dropoffs.length" type="select" :label="$t('form.label.dropoff-location')" :options="dropoffLocations(activityCartItem.details)" icon="dropoff" v-model="activityCartItem.dropoffLocation"/>
                    <form-input v-if="activityCartItem.details && activityCartItem.details.enableDropoffSelectionOnline" type="text" :label="$t('form.label.dropoff-address')" icon="dropoffaddress" v-model="activityCartItem.dropoffAddress"/>


                    <option-choices :cartItem="activityCartItem" />

                    <meal-choices v-if="activityCartItem.details && activityCartItem.details.hasLunch" :cartItem="addPax(activityCartItem)" :guestPicker="$refs.guestPicker" :key="cartItem.itemId" />
                  </div>

                </div>
                <!-- ITEM end -->

              </div>
              <!-- DAY end -->

            </div>

          </div>

          <!-- Availability -->
          <div>
            <p class="availability" v-if="model.liveAvailability" v-html='availabilityMessage'></p>
            <p class="availability error" v-if="model.liveAvailability && !model.liveAvailability.bookable" v-html='availabilityError'></p>
          </div>

          <!-- Same as Activity page >>>>> -->
          <!-- TODO: display cartitem subtotal here -->
          <div class="total-price">{{ $t('general.label.total') }}:<span>{{ $formatter.currency(cartItem.subTotal) }}</span></div>
          <button class="button-book" :class="{ active: buttonActive }" @click="onAddToCart">{{ $t('form.label.add-to-cart') }}</button>
          <!-- Same as Activity page <<<<< -->
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import moment from 'moment';
import GuestPicker from '@/components/GuestPicker.vue';
import FormInput from '@/components/FormInput.vue';
import Package from '@/models/Package';
import Activity from '@/models/Activity';
import Product from '@/models/Product';
import Category from '@/models/Category';
import PAP from '@/mixins/pap';
import dateItem from '@/mixins/dateItem';
import PortalSettings from '@/models/PortalSettings';
import AvailabilityCalendar from '@/components/AvailabilityCalendar.vue';
import activityItem from '@/mixins/activityItem';
import Duration from '@/components/Duration.vue';
import MealChoices from '@/components/MealChoices.vue';
import OptionChoices from '@/components/OptionChoices.vue';

import Cart from '@/models/Cart';
import CartItem from '@/models/CartItem';

export default {
  mixins: [ PAP, dateItem, activityItem ],

  data() {
    return {
      type: 'package', // for mixins
      maxGuests: 12,
      bookNowActive: false,
      giftCertActive: false,
      paxPrefix: '',
      prevPax: undefined,
      dateChanged: false,
      prevDates: undefined,
      prevStartTimes: undefined,
      loading: false,
      cartItem: new CartItem(),
    }
  },

  computed: {
    model() {
      return Package.find(this.id) || new Package();
    },

    duration(){
      let durationSum = 0;
      this.model.activities.forEach(activity => {
        let duration = activity.duration.split(':')
        if(duration.length > 2){
          durationSum += (+duration[0]) + (+duration[1])/60;
        }
      })
      if(durationSum !== 0){
        //Round to nearest 0.5
        return Math.round(durationSum*2)/2;
      }
      return 0;
    },

    buttonActive() {
      let bookable = this.model.liveAvailability !== undefined && this.model.liveAvailability.bookable;

      bookable = bookable && this.selectedStartTimesValid && this.selectedPickupsValid && !this.loading;

      return bookable;
    },

    // gets the currently selected activity dates
    selectedDates() {
      let dates = undefined;
      if(this.cartItem.packageActivities !== undefined) {
        dates = this.cartItem.packageActivities.map((activity, index) => {
          return {
            itemId: activity.itemId,
            date: activity.date
          };
        });
      }
      return dates;
    },

    // gets the currently selected start times for all interval activities in the package
    selectedStartTimes() {
      let startTimes = undefined;
      if(this.cartItem.packageActivities !== undefined) {
        startTimes = this.cartItem.packageActivities.filter(item => item.details && item.details.activityType === "interval").map((activity, index) => {
          return {
            itemId: activity.itemId,
            startTime: activity.startTime
          };
        });
      }
      return startTimes;
    },
    // checks that the selected start time for each interval activity is valid
    selectedStartTimesValid() {
      let valid = true;
      if(this.cartItem.packageActivities !== undefined) {
        this.cartItem.packageActivities.map((activity, index) => {
          if(activity.details && activity.details.activityType === "interval") {
            if(activity.startTime === undefined) {
              valid = false;
            } else {
              let intervalDateTime = moment(moment(activity.date).format('YYYY-MM-DD') + " " + activity.startTime + ':00');
              // check if this timeslot has passed
              if(intervalDateTime.isSameOrBefore(moment())) {
                valid = false;
              }
            }
          }
        });
      }
      return valid;
    },

    requiredFrontEndPickup() {
      return PortalSettings.get('requiredFrontEndPickup');
    },

    selectedPickupsValid() {
      let valid = true;

      if(!this.requiredFrontEndPickup) {
        return true;
      }

      if(this.cartItem.packageActivities !== undefined) {
        this.cartItem.packageActivities.map((activity, index) => {
          if(activity.details && activity.details.pickups.length && !activity.pickupLocation) {
            valid = false;
            return;
          }
        });
      }

      return valid;
    },

    // TODO Kabir - this was copied from Activity.vue and may be different for packages
    availabilityMessage() {
      let message = "";
      let remaining = this.model.liveAvailability.remaining;

      if(remaining !== undefined && remaining !== "") {
        message = this.$t("availability.spots-remaining", {0: remaining});
      }

      return message;
    },

    availabilityError() {
      let message = "";

      // if the activity is not bookable, build the localized error message
      if(this.model.liveAvailability.bookable == false) {
        let error = this.model.liveAvailability.error;

        for(let key in error) {
          let translationKey = error[key]["translation-key"];
          let translationFields = error[key]["translation-fields"];

          if(translationKey == 'LANG_MIN_TIME') {
            // format the minimum time
            let minTimeArray = translationFields[0];
            let days  = minTimeArray['d'] > 0 ? this.$tc("general.label.day-lowercase", minTimeArray['d'], { count: minTimeArray['d'] }) + ", " : "";
            let hours = minTimeArray['h'] > 0 ? this.$tc("general.label.hour-lowercase", minTimeArray['h'], { count: minTimeArray['h'] }) + ", " : "";
            let mins  = minTimeArray['m'] > 0 ? this.$tc("general.label.minute-lowercase", minTimeArray['m'], { count: minTimeArray['m'] }) + ", " : "";
            let secs  = minTimeArray['s'] > 0 ? this.$tc("general.label.second-lowercase", minTimeArray['s'], { count: minTimeArray['s'] }) + ", " : "";
            translationFields[0] = (days + hours + mins + secs).slice(0, -2); // remove the last comma
          }

          // build the translation
          message += this.$t("availability.error." + translationKey, translationFields);
        }
      }

      return message;
    },

    packageImage(){
      return (this.model.image ? this.model.image : require('../assets/images/abstract.png'))
    },

    showLowestPrice() {
      return PortalSettings.get('showLowestPrice', true);
    },
  },

  watch: {
    model (val){
      this.$forceUpdate();
    },
    activeDate(val) {
      this.updateDates();
    },

    // update the activity model when the pax changes.
    'cartItem.pax': function(val) {
      let paxChanged = false;

      // if prevPax has already been set, check if the pax have changed.
      if(this.prevPax !== undefined) {
        for(let key in val) {
          if(val[key] !== this.prevPax[key]) {
            paxChanged = true;
          }
        }

        for(let key in this.prevPax) {
          if(val[key] !== this.prevPax[key]) {
            paxChanged = true;
          }
        }
      }

      // if the pax have changed, refresh the model
      if(paxChanged) {
        this.refreshModel();
      }

      // save the pax so we can compare the values the next time it changes
      this.prevPax = val;
    },

    'selectedDates': function(val) {
      let datesChanged = false;

      // if prevDates has already been set, check if any of the activity dates have changed.
      //
      // NOTE: if an activity's date has changed, the dates for the activities sequentially after that activity may also
      // change because of our minimum booking dates logic. In such a case, we only want to refresh the model once, and
      // avoid having a cascading effect of model refreshes. To do this we also need to check that 'this.dateChanged'
      // is not true, which when true means we've just refreshed the model because of a date change.
      if(this.prevDates !== undefined && !this.dateChanged) {
        // find the activity whose date has changed
        for (var i = 0; i < this.prevDates.length; i++) {
          if(this.prevDates[i].date !== val[i].date) {
            datesChanged = true;
            this.dateChanged = true;
            this.cartItem.packageActivities[i].dateChanging = true;
            break;
          }
        }
      } else {
        //
        this.dateChanged = false;
      }
      // if any of the activity dates have changed, refresh the model
      if(datesChanged) {
        this.refreshModel();
      }
      // save the activity dates so we can compare the values the next time they change
      this.prevDates = val;
    },

    'selectedStartTimes': function(val) {
      let startTimesChanged = false;
      // if prevStartTimes has already been set, check if the start times have changed.
      if(this.prevStartTimes !== undefined && JSON.stringify(this.prevStartTimes) !== JSON.stringify(val)) {
        startTimesChanged = true;
      }
      // if any of the start times have changed, refresh the model
      if(startTimesChanged) {
        this.refreshModel();
      }
      // save the start times so we can compare the values the next time they change
      this.prevStartTimes = val;
    }
  },

  methods: {
    addPax(item){
      item.pax = this.cartItem.pax;
      return item;
    },
    menuCaretClick(id, event){
      event.target.classList.toggle("down");
      this.$refs[`section_${id}`][0].classList.toggle("collapsed");
    },
    pickupLocations(obj) {
      return obj.pickups.map(x => {
        return {
          label: x.name,
          value: x.id
        };
      });
    },
    dropoffLocations(obj) {
      return obj.dropoffs.map(x => {
        return {
          label: x.name,
          value: x.id
        };
      });
    },

    // the start time dropdown options
    startTimes(activity) {
      let times = [];
      if (activity.details && activity.details.activityType === 'interval') {
        times = this.intervalTimes(activity);
      } else if (activity.details && activity.details.activityType === 'rental') {
        if (activity.details.hasCustomRentalTimes) {
          if (this.selectedCustomRentalTime(activity).times) {
            times = this.selectedCustomRentalTime(activity).times.map(item => {
              return {
                value: `${item}`,
                label: moment(item, 'HH:mm').format('h:mm a')
              };
            });
          }
        } else if (this.isMultiDayRental(activity)) {
          // if it's multi day rental then anything goes.
          times = this.intervalTimes(activity);
        } else {
          // If this is a rental activity, we don't let the customer pickup on the very last available time
          times = this.intervalTimes(activity).slice(0, -1);
        }
      }

      return times;
    },

    // we want to filter out any times on or before the current startTime
    dropoffTimes(activity) {
      let curStartTime = moment(activity.startTime, 'HH:mm:ss');
      return this.isMultiDayRental(activity) ? this.intervalTimes(activity) : this.intervalTimes(activity).filter(item => {
        return moment(item.value, 'HH:mm:ss').isAfter(curStartTime);
      });
    },

    // used for interval and rental activities
    intervalTimes(activity) {
      let times = [];

      if (activity.details && activity.details.activeAvailability.startTime) {
        let st = activity.details.activeAvailability.startTime;
        let et = activity.details.activeAvailability.endTime;

        if (activity.details.interval && activity.details.interval != "00:00:00") {
          let cur = moment(st, 'HH:mm:ss');
          let end = moment(et, 'HH:mm:ss');
          let interval = moment.duration(activity.details.interval);
          while (cur.isSameOrBefore(end)) {
            let intervalDateTime = moment(moment(activity.date).format('YYYY-MM-DD') + " " + cur.format('HH:mm:ss'));

            // check if this timeslot has passed
            if(intervalDateTime.isSameOrAfter(moment())) {
              times.push({
                value: cur.format('HH:mm'),
                label: cur.format('h:mm a')
              });
            }

            cur.add(interval);
          }
        }
      }

      return times;
    },

    refreshModel(hard = false) {
      // disable the "add to cart" button while we refresh the model
      this.loading = true;

      // set the package start date
      this.cartItem.date = moment(this.activeDate).format('YYYY-MM-DD');

      Package.fetch(this.id, this.cartItem).then(data => {
        // re-enable the "add to cart" button
        this.loading = false;

        this.resetItem(hard, data);

        if (hard) {
          Category.fetch(this.type, this.model.category);
        }
      });
    },

    resetItem(hard = false, data = null) {
      let defaults = {
        itemId: this.id,
        type: 'package',
        startTime: this.model.listStartTime,
        pax: this.cartItem.pax,
        packageActivities: this.cartItem.packageActivities
      };

      if (hard) {
        // model has updated so set the prefix so guest-picker uses correct lang overrides.
        this.paxPrefix = `package${this.id}.`;
        this.$refs.guestPicker.reset();

        defaults.pax = this.guestPickerPax;
      }

      // set up a cartItem for each activity
      defaults.packageActivities = this.model.activities.map((activity, index) => {
        let activityCartItem = (this.cartItem.packageActivities !== undefined) ? this.cartItem.packageActivities[index] : undefined;
        let options = [];

        if (activity.options) {
          options = activity.options.map(option => {
            let sel = activityCartItem ? activityCartItem.options.find(o => o.id === option.categoryId) : undefined;
            return {
              id: option.categoryId,
              value: sel ? sel.value : 0
            }
          });
        }

        let obj = new CartItem({
          itemId: activity.id,
          type: 'activity',
          startTime: activityCartItem ? activityCartItem.startTime : activity.listStartTime.slice(0, -3), // remove seconds :00
          endTime: activityCartItem ? activityCartItem.endTime : undefined,
          pickupLocation: activityCartItem ? activityCartItem.pickupLocation : undefined,
          dropoffLocation: activityCartItem ? activityCartItem.dropoffLocation : undefined,
          pickupAddress: activityCartItem ? activityCartItem.pickupAddress : undefined,
          dropoffAddress: activityCartItem ? activityCartItem.dropoffAddress : undefined,
          customRentalTime: activityCartItem ? activityCartItem.customRentalTime : undefined,
          rentalEndDate: activityCartItem ? activityCartItem.rentalEndDate : undefined,
          rawRentalEndDate: activityCartItem ? moment(activityCartItem.rentalEndDate).toDate() : undefined, // set the input for the end date calendar in the correct format
          meals: activityCartItem ? activityCartItem.meals : undefined,
          options: options
        });

        // set the activity date passed back from the fetch if it is set, otherwise set it to the active date
        obj.rawDate = (data !== null && data.activities[index].activityDate !== undefined) ? moment(data.activities[index].activityDate).toDate() : this.activeDate;

        return obj;
      });

      this.cartItem = new CartItem(defaults);
      this.updateDates();
    },

    onAddToCart() {
      // console.log('add to cart', this.cartItem);
      this.cartItem.date = moment(this.activeDate).format('YYYY-MM-DD');

      Cart.add(this.cartItem).then(() => {
        this.resetItem();
        this.$router.push({name: 'cart'});
      });
    },

    updateDates() {
      let activities = this.cartItem.packageActivities;
      if (activities) {
        activities.forEach(item => {

          if (item.details && item.details.dayNumber > 0) {
            item.date = moment(this.activeDate).add(item.details.dayNumber - 1, 'days').format('YYYY-MM-DD');
          } else {
            item.date = moment(item.rawDate).format('YYYY-MM-DD');
          }

        });
      }

    },

    bookNowToggle() {
      // TODO Jamie - Add overflow hidden to #app(or body) when this is active
      this.bookNowActive = !this.bookNowActive;
    },

    giftCertToggle() {
      this.giftCertActive = !this.giftCertActive;
    },

    startTimesActive(activity) {
      return activity.activityType === 'interval' || activity.activityType === 'rental';
    },

    endTimesActive(activity) {
      return activity.activityType === 'rental' && !activity.hasCustomRentalTimes;
    },

    isMultiDayRental(activity) {
      return activity.activityType === 'rental' && activity.rentalIsMultiDay;
    },

    selectedCustomRentalTime(activity) {
      let found = activity.details.activeCustomRentalTimes.filter(item => item.value === activity.customRentalTime);
      return found && found.length ? found[0] : {};
    },

    activityOnThisDay(day){
      if (!this.model.activities)
        return false;
      for (var i = 0; i < this.model.activities.length; i++){
        if (this.model.activities[i].dayNumber == day){
          return true;
        }
      }
      return false;
    },
    activitiesOfDay(day){
      return this.model.activities.filter(activity => activity.dayNumber == day);
    },

    shouldShowDayNumber(index, curDay) {
      let acts = this.model.activities;
      return curDay && (index==0 || acts[index-1].dayNumber != curDay) && acts[acts.length-1].dayNumber != curDay;
    }
  },

  components: {
    GuestPicker,
    AvailabilityCalendar,
    FormInput,
    Duration,
    MealChoices,
    OptionChoices
  }
};
</script>

<style lang="scss">

// Copy of Activity page >>>>>
.view.package {
  @include breakpoint(medium) {
    .container {
      display: flex;
      flex-wrap: wrap;
    }
  }

  // Activity info area
  .meta {
    width: 100%;
    margin-bottom: 50px;
    @include breakpoint(medium) {
      width: calc(100% - 330px);
      margin-right: 30px;
    }

    .image-container {
      height: 0;
      overflow: hidden;
      padding-top: 56.25%;
      background: #fff;
      position: relative;
    }

    .image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .icons {
      list-style: none;
      margin: 10px 0 0 0;
      padding: 0;

      li {
        padding: 3px 0;

        > span {
          margin-right: 10px;
          font-size: 20px;
          text-align: center;
          width: 24px;
          color: $colorGray;
        }

        .icon-duration { @include font-awesome($fa-var-hourglass-half, light); }
        .icon-time { @include font-awesome($fa-var-watch, light); }
        .icon-lunch { @include font-awesome($fa-var-utensils, light); }
        .icon-pickup { @include font-awesome($fa-var-bus, light); }
        .icon-gift { @include font-awesome($fa-var-gift-card, light); }
      }
    }

    .description {
      margin: 15px 0 40px 0;
    }

    .note {
      border-top: 1px solid $colorPaleGray;
      padding: 10px 0 30px 0;
    }

    .more-info {
      @include toggle-info;
      border-bottom: none;
    }

    .policy {
      @include toggle-info;
    }
  }


  // Form area
  .form {
    background-color: transparent;
    position: fixed;
    width: 100%;
    margin-top: 400px;
    bottom: 0;
    right: 0;
    z-index: 1;
    transition: background-color .1s ease .4s;

    > .inputs {
      display: none;
    }

    @include breakpoint(medium) {
      bottom: unset;
      width: 300px;
      position: relative;
      margin-top: 0;
      margin-bottom: 50px;
      z-index: unset;

      .inputs {
        width: 100%;
        display: inline-block;
        max-height: none !important;
        padding: 25px 0 15px 0;
        top: 75px;
      }
    }

    // When the mobile form is active
    &.active {
      background-color: #fff;
      height: 100%;
      top: 0;
      margin-top: 0;
      overflow: scroll;
      z-index: 2;
      transition: margin-top .4s;

      > .inputs {
        display: inline-block;
        width: 100%;
      }

      .mobile-fixed-button {
        margin-bottom: 20px;

        .price {
          display: none;
        }

        .mobile-book-now {
          visibility: hidden;

          &::before {
            @include font-awesome-pseudo($fa-var-times, light);
            color: $colorGray;
            visibility: visible;
            position: absolute;
            top: 15px;
            right: 15px;
            cursor: pointer;
            font-size: 30px;
          }
        }
      }

      .inputs {
        max-height: 500px;
        overflow: unset;
        transition: max-height .4s;
      }
    }
  }

  .mobile-fixed-button {
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
    margin-bottom: 45px;

    @include breakpoint(medium) {
      display: none;
    }

    .from {
      @include font-smallest;
      color: #fff;
      opacity: .8;
      margin-right: 3px;
    }

    .price {
      opacity: .8;
      margin-right: 3px;

      &::after {
        content: '|';
        margin-left: 5px;
        opacity: .2;
      }
    }

    .mobile-book-now {
      @include button($colorCTA, #fff);
      border-radius: 30px;
      box-shadow: 1px 3px 3px rgba(0,0,0,.2);
    }
  }

  // Gift Certificate switch
  .gift-switch-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 20px;
  }

  .gift-switch-icon {
    @include font-smaller;
    color: $colorDarkGray;
    margin-right: 4px;

    &::before {
      @include font-awesome-pseudo($fa-var-gift, light);
      font-size: 20px;
      margin-right: 4px;
    }
  }

  .gift-switch {
    @include switch;
  }

  .inputs {
    .gift-inputs {
      display: none;
    }

    &.active {
      .gift-inputs {
        display: block;
      }
      .default-inputs {
        display: none;
      }
    }
  }

  .inputs {
    padding: 0 15px;
    max-height: 0;
    transition: all .6s;

    .date .icon { @include font-awesome($fa-var-calendar-alt, light); }
    .firstname .icon { @include font-awesome($fa-var-smile, light); }
    .lastname .icon { @include font-awesome($fa-var-smile, light); }
    .giftmessage .icon { @include font-awesome($fa-var-comment-dots, light); }
    .time .icon { @include font-awesome($fa-var-watch, light); }
    .pickup .icon { @include font-awesome($fa-var-map-marker-alt, light); }
    .pickupaddress .icon { @include font-awesome($fa-var-map-marker-edit, light); }
    .dropoff .icon { @include font-awesome($fa-var-map-marker-alt, light); }
    .dropoffaddress .icon { @include font-awesome($fa-var-map-marker-edit, light); }
    .option .icon { @include font-awesome($fa-var-plus, light); }
    .meal .icon { @include font-awesome($fa-var-utensils, light); }
    .mealcomment .icon { @include font-awesome($fa-var-comment-dots, light); }
  }


  // Option
  .option-container {
    display: flex;
    margin-bottom: 20px;

    > div {
      width: 100%;
    }
  }

  .option-input {
    display: grid;
    display: -ms-grid;
    grid-template-columns: 1fr 100px;
    -ms-grid-columns: 1fr 100px;
    grid-gap: 10px;
    align-items: center;
    width: 100%;

    /*  IE */
    @media all and (-ms-high-contrast:none) {
      .quantity-picker {
        -ms-grid-column: 2;
      }
    }

    input {
      background-color: transparent;
    }
  }

  .option-name {
    @include font-input;
  }

  .option-price {
    color: $colorGray;
  }

  .option-description {
    @include font-small;
    color: $colorGray;
    margin-top: 3px;
  }


  .total-price {
    @include font-h2;
    @include form-border-top;
    text-align: right;
    margin-top: 25px;
    margin-bottom: 20px;

    &::before {
      width: 100%;
      margin: 0 0 15px;
    }

    span {
      margin-left: 10px;
    }
  }

  .button-book {

    @include inactive-button($colorCTA, #fff);
    width: 100%;
    margin-bottom: 70px;

    @include breakpoint(medium) {
      margin-bottom: 20px;
    }
  }

  .availability {
    text-align: left;
    margin-bottom: 20px;

    span {
      margin-left: 10px;
    }
  }

  .error {
    color: $colorRed;
  }

  // Upsell area
  .upsell {
    @include full-width;
    background-color: $colorBgGray;
    padding-top: 20px;
    padding-bottom: 20px;
    margin-bottom: 20px;
    @include breakpoint(medium) {
      background-color: #fff;
    }

    h2 {
      margin-bottom: 15px;
    }
  }

  .packages {
    @include grid-list;
    @include breakpoint(medium) {
      margin: 0 -8px;
    }

    ol li {
      margin-bottom: 25px;
    }

    .package-list {
      display: flex;
      box-shadow: 0 1px 5px 1px rgba(0,0,0,0.2);
      color: #222;
      background-color: #fff;
      @include breakpoint(medium) {
        flex-wrap: wrap;
        height: 100%;
        align-content: flex-start;
      }
    }

    .package-image {
      object-fit: cover;
      width: 100px;
      height: 100px;
      @include breakpoint(medium) {
        height: 185px;
        width: 100%;
      }
    }

    .package-info {
      padding: 12px;
      width: 100%;
    }

    .package-name {
      @include font-h3;
      margin-bottom: 5px;
    }

    .package-icons {
      @include item-list-icons;
    }

    .package-price {
      @include font-h2;
      @include breakpoint(medium) {
        text-align: right;
      }

      .from {
        @include from;
        margin-right: 5px;
      }
    }
  }
}
// Copy of Activity page <<<<<


.vdp-datepicker {
  > div {
    > input {
      width: 100%;
    }
  }
}


// Package only >>>>>
.view.package {
  .item {
    padding: 30px;
    padding-left: 0;
    padding-right: 0;
    border-bottom: 1px solid $colorPaleGray;
  }

  .item-image-container {
    display: grid;
    grid-template-columns: 80px 1fr;
    grid-column-gap: 10px;
    align-items: center;
    @include breakpoint(medium) {
      grid-template-columns: 100px 1fr;
      grid-column-gap: 15px;
    }
  }

  .content {
    padding: 24px 0 18px 0;
    @include breakpoint(medium) {
      padding: 50px 0;
    }
  }

  .content-header {
    font-size: 20px;
  }

  .day {
    padding-bottom: 15px;
    border-bottom: 1px solid $colorPaleGray;
  }

  .item-image {
    object-fit: cover;
    width: 80px;
    height: 80px;
    @include breakpoint(medium) {
      width: 100px;
      height: 100px;
    }
  }

  .item-name {
    @include font-h3;
    margin-bottom: 10px;
    @include breakpoint(medium) {
      font-size: 18px;
    }
  }

  .item-description {
    margin-top: 10px;
  }

  .item-note {
    margin-top: 10px;
  }

  .item-toggle-button {
    display: none;

    + label {
      color: $colorCTA;
      align-items: center;
      cursor: pointer;
      &:hover {
        filter: brightness(1.3);
        // color: lighten($colorCTA, 10);
      }

      &::before {
        content: none;
      }

      &::after {
        @include font-awesome-pseudo($fa-var-chevron-down, light);
        margin-left: 5px;
      }
    }

    ~ p {
      margin-bottom: 0;
      max-height: 0;
      overflow: hidden;
    }

    &:checked {
      + label::after {
        transform: rotate(-180deg);
      }

      ~ p {
        max-height: 500px;
        overflow: auto;
        transition: all .2s;
      }
    }
  }

  .item-specific-inputs {
    &::before {
      width: 100%;
      margin: 0 0 15px;
    }
  }

  .item-container {
    margin-top: 20px;
    > .activity-section {
      background-color: $colorBgGray;
      transition: padding-top 0.2s, padding-bottom 0.2s;

      &.collapsed {
        padding: 0px;
        height: 0px;
        > * {
          height: 0px;
          overflow: hidden;
          &::before {
            display: none;
          }
        }
        > * span {
          display: none;
        }
      }

      &:not(.collapsed) {
        padding: 20px 15px 5px 15px;
      }
    }
  }


  .textarea{
    textarea{
      padding-left: 40px;
    }
  }

  .activity-bar {
    padding: 15px;
    background-color: $colorDarkGray;
    color: #fff;
    > .info {
      max-width: 80%;
      display: inline-block;
      > h3 {
        margin-top: 6px;
        margin-bottom: 2px;
        font-weight: 500;
      }
    }
  }

  .caret {
    transition: transform 0.3s;
    &::before {
      @include font-awesome-pseudo($fa-var-caret-circle-down, light);
    }

    &:not(.down) {
      transform: rotate(180deg);
    }

    float: right;
    font-size: 28px;
    color: #fff;
  }

  .day-container {
    margin-bottom: 25px;
  }

  .day-number {
    background-color: $colorBgDarkGray;
    color: #fff;
    padding: 3px 15px;
    display: inline-block;
  }

  .meal-title {
    margin-bottom: 12px;
  }
}
</style>